import { BASE_URL, SET_ADMIN_REFERRAL, SET_USER } from "./types";
import Axios from "axios";
import Swal from "sweetalert2";
import { setLoader } from "./userAction";

// Create custom referral code
export const setAdminReferral = (data) => async (dispatch) => {
    try {
        dispatch({ type: SET_ADMIN_REFERRAL, payload: data });
    } catch (error) {
        console.log(error);
    }
};
export const setUser = (data) => async (dispatch) => {
    try {
        dispatch({ type: SET_USER, payload: data });
    } catch (error) {
        console.log(error);
    }
};
export const createCustomReferralCode =
    ({ data, onSuccess }) =>
    async (dispatch) => {
        dispatch(setLoader(true));
        try {
            const resp = await Axios.post(
                `${BASE_URL}/api/customReferralCode`,
                data,
                {
                    withCredentials: true,
                }
            );
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Custom Referral Code Created",
                showConfirmButton: false,
                timer: 1500,
            });
            if (onSuccess) onSuccess(resp.data);
        } catch (error) {
            const errorMsg = error?.response?.data?.errorMsg;
            if (errorMsg) {
                Swal.fire({
                    icon: "error",
                    title: "Error Occurred",
                    text: errorMsg,
                });
            }
            console.log(error);
        }
        dispatch(setLoader(false));
    };

// Read/Get custom referral code(s)
export const getByIdCustomReferralCode = (id, params) => async (dispatch) => {
    console.log(id);

    dispatch(setLoader(true));
    try {
        const resp = await Axios.get(
            `${BASE_URL}/api/customReferralCode/${id}`,
            {
                withCredentials: true,
            }
        );
        dispatch(setLoader(false));
        return resp?.data;
    } catch (error) {
        console.log(error);
    }
    dispatch(setLoader(false));
};

// Read/Get custom referral code(s)
export const getCustomReferralCode = (params) => async (dispatch) => {
    dispatch(setLoader(true));
    try {
        const resp = await Axios.get(`${BASE_URL}/api/customReferralCode`, {
            params,
            withCredentials: true,
        });
        dispatch(setLoader(false));
        return resp?.data;
    } catch (error) {
        console.log(error);
    }
    dispatch(setLoader(false));
};

// Update custom referral code
export const updateCustomReferralCode =
    (id, { data, onSuccess }) =>
    async (dispatch) => {
        console.log(id);
        dispatch(setLoader(true));
        try {
            const resp = await Axios.put(
                `${BASE_URL}/api/customReferralCode/${id}`,
                data,
                {
                    withCredentials: true,
                }
            );
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Custom Referral Code Updated",
                showConfirmButton: false,
                timer: 1500,
            });
            if (onSuccess) onSuccess(resp.data);
        } catch (error) {
            const errorMsg = error?.response?.data?.errorMsg;
            if (errorMsg) {
                Swal.fire({
                    icon: "error",
                    title: "Error Occurred",
                    text: errorMsg,
                });
            }
            console.log(error);
        }
        dispatch(setLoader(false));
    };

// Delete custom referral code
export const deleteCustomReferralCode =
    ({ id, onSuccess }) =>
    async (dispatch) => {
        dispatch(setLoader(true));
        try {
            await Axios.delete(`${BASE_URL}/api/customReferralCode/${id}`, {
                withCredentials: true,
            });
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Custom Referral Code Deleted",
                showConfirmButton: false,
                timer: 1500,
            });
            if (onSuccess) onSuccess();
        } catch (error) {
            const errorMsg = error?.response?.data?.errorMsg;
            if (errorMsg) {
                Swal.fire({
                    icon: "error",
                    title: "Error Occurred",
                    text: errorMsg,
                });
            }
            console.log(error);
        }
        dispatch(setLoader(false));
    };

export const getDWRequests = (data) => async (dispatch) => {
    dispatch(setLoader(true));
    try {
        const resp = await Axios.post(
            `${BASE_URL}/api/customReferralCode/dw/requests`,
            data,
            {
                withCredentials: true,
            }
        );
        dispatch(setLoader(false));
        return resp?.data;
    } catch (error) {
        console.log(error);
    }
    dispatch(setLoader(false));
};

export const getDWRequestById = (id) => async (dispatch) => {
    dispatch(setLoader(true));
    try {
        const resp = await Axios.get(
            `${BASE_URL}/api/customReferralCode/dw/requests/${id}`,
            {
                withCredentials: true,
            }
        );
        dispatch(setLoader(false));
        return resp?.data;
    } catch (error) {
        console.log(error);
    }
    dispatch(setLoader(false));
};

export const updateDWRequestData =
    ({ data, navigate }) =>
    async (dispatch) => {
        dispatch(setLoader(true));
        try {
            const resp = await Axios.post(
                `${BASE_URL}/api/customReferralCode/dw/request/update`,
                data,
                {
                    withCredentials: true,
                }
            );
            dispatch(
                setUser({
                    name: "shouldAddMessage",
                    value: false,
                })
            );
            dispatch(
                setUser({
                    name: "messageText",
                    value: "",
                })
            );
            dispatch(setLoader(false));
            navigate("/dw-requests");
        } catch (error) {
            console.log(error);
        }
        dispatch(setLoader(false));
    };
